export default "__VITE_ASSET__D2pNA8xl__"